import { 
  doc, 
  getDoc, 
  setDoc, 
  updateDoc, 
  arrayUnion, 
  arrayRemove,
  serverTimestamp 
} from 'firebase/firestore';
import { db, auth } from '../config/firebase';

export class WishlistService {
  static async addToWishlist(productId) {
    try {
      if (!auth.currentUser) {
        throw new Error('You must be logged in to add items to wishlist');
      }

      const wishlistRef = doc(db, 'wishlists', auth.currentUser.uid);
      const wishlistDoc = await getDoc(wishlistRef);

      if (!wishlistDoc.exists()) {
        // Create new wishlist if it doesn't exist
        await setDoc(wishlistRef, {
          userId: auth.currentUser.uid,
          items: [productId],
          updatedAt: serverTimestamp()
        });
      } else {
        // Update existing wishlist
        await updateDoc(wishlistRef, {
          items: arrayUnion(productId),
          updatedAt: serverTimestamp()
        });
      }
    } catch (error) {
      console.error('Error adding to wishlist:', error);
      throw new Error('Failed to add item to wishlist');
    }
  }

  static async removeFromWishlist(productId) {
    try {
      if (!auth.currentUser) {
        throw new Error('You must be logged in to remove items from wishlist');
      }

      const wishlistRef = doc(db, 'wishlists', auth.currentUser.uid);
      await updateDoc(wishlistRef, {
        items: arrayRemove(productId),
        updatedAt: serverTimestamp()
      });
    } catch (error) {
      console.error('Error removing from wishlist:', error);
      throw new Error('Failed to remove item from wishlist');
    }
  }

  static async getWishlist() {
    try {
      if (!auth.currentUser) {
        throw new Error('You must be logged in to view wishlist');
      }

      const wishlistRef = doc(db, 'wishlists', auth.currentUser.uid);
      const wishlistDoc = await getDoc(wishlistRef);

      if (!wishlistDoc.exists()) {
        return { items: [] };
      }

      return wishlistDoc.data();
    } catch (error) {
      console.error('Error getting wishlist:', error);
      throw new Error('Failed to get wishlist');
    }
  }

  static async isInWishlist(productId) {
    try {
      if (!auth.currentUser) return false;

      const wishlistRef = doc(db, 'wishlists', auth.currentUser.uid);
      const wishlistDoc = await getDoc(wishlistRef);

      if (!wishlistDoc.exists()) return false;

      return wishlistDoc.data().items.includes(productId);
    } catch (error) {
      console.error('Error checking wishlist:', error);
      return false;
    }
  }
} 